import React from 'react';
import { Link } from 'shared-routing';
import { Routes } from '@common/constants';
import ImgixWrapper from '@common/components/ImgixWrapper';
import { Container } from './Logo.styles';

type LogoProps = {
  logo: {
    externalKey: string;
    url: string;
  } | null;
  name: string;
};

export function Logo({ logo, name }: LogoProps) {
  const homepageUrl = () => {
    return Routes.HOME;
  };

  return (
    <>
      {logo && (
        <Container>
          <Link route={homepageUrl()}>
            <ImgixWrapper src={logo.url} height={77} alt={name} />
          </Link>
        </Container>
      )}
    </>
  );
}
